import React from 'react'
import {Link} from 'react-router-dom'
import {Grid} from '@mui/material'
import {Demand, Dojo , Comment} from '../../component/fiture'
import {Robot , Head , Database , Light, Help, Team , DojoTouch} from '../../assets/img'
import {Gov , Analitics , Business , Mark1 , Mark2, Transformation} from '../../assets/svg'
import './home.scss'

function Index() {

    const Scroll = () => window.scrollTo({behavior : 'smooth' , top : 0})
    
    return (
        <div className="home">
            <div className="jumbotron">
                <Grid container className="wrapper">
                    <Grid className="column-1" md={6} lg={6} >
                        <h3 className='title'>Enriching Individuals, Empowering Business</h3>

                        <p className="body">We create a learning experience that combines business practices with data analysis to unlock its hidden potential. </p>

                        <div className="action">
                            <Link to="/about" className='button'>About Us</Link>
                            {/* <Link to="/get-in-touch" className='button'>Join Us Now!</Link> */}
                        </div>
                    </Grid>

                    <Grid className="column-2" md={6} lg={5}>
                        <img src={Robot} alt='' />
                    </Grid>
                </Grid>
            </div>

            <div className="deliver">
                <h3 className="title">The Values We Deliver</h3>

                <div className="do">
                    <Grid container>
                        <Grid item className="column" xs={12} sm={12} md={4} lg={4}>
                            <img className="img" src={Head} alt="" />
                            <h3 className="subtitle">Practical Learning</h3>
                            <p className="body">Providing you with relevant case studies and assisting you to solve business issues.</p>
                        </Grid>

                        <Grid item className="column" xs={12} sm={12} md={4} lg={4}>
                            <img className="img" src={Light} alt="" />
                            <h3 className="subtitle">Action Oriented</h3>
                            <p className="body">You will be challenged to come up with new ideas and get them validated.</p>
                        </Grid>

                        <Grid item className="column" xs={12} sm={12} md={4} lg={4}>
                            <img className="img" src={Database} alt="" />
                            <h3 className="subtitle">Data Savvy</h3>
                            <p className="body">Rather than telling, we help you to change your perspective.</p>
                        </Grid>
                    </Grid>
                </div>
            </div>

            <div className="help">
                <Grid container className="wrapper">
                    <Grid item md={5} lg={5} className="column-1">
                        <div>
                            <img className="img" src={Help} alt="" />
                        </div>
                    </Grid>

                    <Grid item sm={12} md={7} lg={7} className="column-2">
                        <h3 className="title">How We Can Help You</h3>

                        <div className="information">
                            <div className="item-1">
                                <h3>Starting From You</h3>
                                <p>We will start with understanding more about your needs and the challenges you faced. Dattabot Dojo will analyze your issue, and then come up with a learning design that suits your need.</p>
                            </div>

                            <div className="item-2">
                                <h3>Exploring Your Idea</h3>
                                <p>Depending on the technique used, each learning design will take
                                    2-4 weeks to complete. Every learning design Dattabot Dojo creates should and must deliver results in a 
                                    form of ideation about Data Analytics projects coming from their respective functions.</p>
                            </div>

                            <div className="item-3">
                                <h3>The Implementation</h3>
                                <p>After the workshop's end and the reports' documentation, a fresh possibility for cooperation may be a future follow-up from both parties into turning ideas into action. Dattabot will assist with technology-related delivery planning, organization, and action
                                    steps for execution to facilitate future cooperation.</p>
                            </div>
                        </div>
                    </Grid>
                </Grid>
            </div>


            <div className="training">
                <h3 className="title">The Core of The Training</h3>
                
                <div className='wrap'>
                <Grid className="wrapper" container justifyContent="space-between" >
                    <Grid item className="item active" sm={4} md={3} lg={2.8}>
                        <img className="img" src={Transformation} alt="" />
                        <h3 className="subtitle active">
                            Digital <br />
                            Transformation
                        </h3>
                        <p className="body">The first stage in the process of using technology to change current conventional 
                            business processes to suit evolving industry requirements.
                        </p>
                    </Grid>

                    <Grid item className="item" sm={4} md={3} lg={2.8}>
                        <img className="img" src={Gov} alt="" />
                        <h3 className="subtitle">
                            Data <br />
                            Governance
                        </h3>
                        <p className="body">How to manage the existing data to improve business processes. 
                            In this process, you will envision the way the data is used or ruled.
                        </p>
                    </Grid>

                    <Grid item className="item" sm={4} md={3} lg={2.8}>
                        <img className="img" src={Analitics} alt="" />
                        <h3 className="subtitle">
                            Data <br />
                            Analytics
                        </h3>
                        <p className="body">The process of examining data sets to find trends and draw conclusions about 
                            the information they contain.
                        </p>
                    </Grid>

                    <Grid item className="item" sm={4} md={3} lg={2.8}>
                        <img className="img" src={Business} alt="" />
                        <h3 className="subtitle">
                            Business <br />
                            Intelligence
                        </h3>
                        <p className="body">How we communicate key findings to you throughout the digital transformation process. 
                            Storytelling is everything in this process.
                        </p>
                    </Grid>
                </Grid>
                </div>
            </div>


            <div className="courses">
                <h3 className="course-title">Join Our Courses!</h3>

                <div className='wrapper'>
                    <div className="wrapper-header">
                        <h3 className="title">Dattabot Dojo Programs</h3>
                        <Link className="action" to="/courses">See All {'>'}</Link>
                    </div>

                    <Dojo /> 
                </div>

                <div className='wrapper'>
                    <div className="wrapper-header">
                        <h3 className="title">Most in Demand</h3>
                        <Link className="action" to="/courses">See All {'>'}</Link>
                    </div>

                    <Demand />
                </div>

            </div>

            <div className='comment'>
                <Grid className='wrapper' container>
                    <Grid className='column-1' md={6} lg={6}>
                        <p className='img-wrapper'>
                            <img src={Mark1} alt="" />
                            <img src={Mark2} alt="" />
                        </p>

                        <h3 className='title'>What They Say About</h3>
                        <p className='body'>We collect testimonials from great alumni of Dattabot Dojo who have felt the benefits 
                            of joining and participating in every class offered. What are you waiting for it's time to join us!
                        </p>
                    </Grid>

                    <Grid className='column-2' md={6} lg={6}>
                        <Comment />
                    </Grid>
                </Grid>
            </div>

            
            <div className='connect'>
                <Grid container className='wrapper'>
                    <Grid item className='column' sm={5} md={5} lg={4.5}>
                        <img src={Team} alt="" />
                    </Grid>

                    <Grid item className='column' sm={7} md={7} lg={7.5} >
                        <h3 className='title'>Unlock Your Team's Best <br /> Potential With Dattabot Dojo</h3>
                        <p className='sub'>Choose the best program for your learning needs now</p>
                        {/* <Link to="/training" className="link">Talk With Our Team {'>'}</Link> */}
                    </Grid>
                </Grid>
            </div>

            {/* <div className='touch'>
                <div className='touch-img'>
                    <img src={DojoTouch} alt="" />
                </div>
                <div className='word'>
                    <h3 className='title'>How To Get In Touch <br /> With Us</h3>

                    <div className='button'>
                        <Link to="/get-in-touch" className="link">Connect With Us</Link>
                    </div>
                </div>
               
            </div> */}

            <button className='back' onClick={Scroll}>Kembali Ke Atas</button>
        </div>
    )
}

export default Index
